(function () {
  function getFieldFromEvent(e) {
    return e.target.closest('#rsi_form_wrapper input, #rsi_form_wrapper textarea, #rsi_form_wrapper select');
  }

  function focusField(field) {
    if (!field) return;

    try {
      field.removeAttribute('readonly');
      field.focus({ preventScroll: true });

      if (field.tagName === 'INPUT' || field.tagName === 'TEXTAREA') {
        const len = field.value ? field.value.length : 0;
        if (typeof field.setSelectionRange === 'function') {
          field.setSelectionRange(len, len);
        }
      }

      field.click();
    } catch (err) {}
  }

  document.addEventListener('touchend', function (e) {
    const field = getFieldFromEvent(e);
    if (!field) return;

    focusField(field);
  }, { passive: true });

  document.addEventListener('click', function (e) {
    const field = getFieldFromEvent(e);
    if (!field) return;

    focusField(field);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('#rsi_form_wrapper');
    if (!wrapper) return;

    wrapper.style.pointerEvents = 'auto';

    const fields = wrapper.querySelectorAll('input, textarea, select');
    fields.forEach(function (field) {
      field.style.pointerEvents = 'auto';
      field.style.position = 'relative';
      field.style.zIndex = '999';
      field.removeAttribute('readonly');
    });
  });
})();